export const analyseTrustPdfMessages = {
  startProcessing: `Give us a moment — we’re having a very serious conversation with your PDF.`,
  successProcessing: `Parsing complete! Please check the fields and update any missing or incorrect information.`,
  errorProcessing: `We were unable to process this document. Try uploading a different file or manually entering the trust details below.`,
  generatedTrustWarning: `The document has been processed and key fields have been filled in automatically. Please review the information carefully and make any necessary adjustments before submitting.`
};
